import React, { useMemo } from 'react';
import { useAuthUserData, useQueryWithSimpleErrorHandling } from 'hooks';
import DashboardContainer from './DashboardContainer';
import { DASHBOARD_IDS_BY_USER_GROUP_QUERY } from '../queries';
import { FakeText } from '@totalsoft/rocket-ui';

const Dashboard = () => {
  const { authUser } = useAuthUserData();

  const userGroup = authUser && authUser?.userGroups[0];

  const { data, loading } = useQueryWithSimpleErrorHandling(DASHBOARD_IDS_BY_USER_GROUP_QUERY, {
    variables: { userGroupId: userGroup?.userGroupId },
    skip: !authUser,
    fetchPolicy: 'no-cache'
  });

  const dashboardIds = useMemo(() => data?.dashboardIdsByUserGroup || [], [data]);

  return loading ? (
    <FakeText lines={10} onPaper />
  ) : (
    dashboardIds.map(id => (
      <DashboardContainer key={id} dashboardId={id} userId={parseInt(authUser.userId)} groupName={userGroup?.userGroupName} />
    ))
  );
};

export default Dashboard;
